import React from 'react';
import {stylesheet} from 'typestyle';
import {Draggable} from 'react-beautiful-dnd';
import {ColorHelper} from 'csx';
import {Shadow1, WhiteColor} from '../../styles/colors';

interface LeftSidebarDragBlockProps {
    index: number;
    draggableId: string;
    dragHandleColor: ColorHelper;
    children?: React.ReactNode;
}

export function LeftSideDragBlock({index, draggableId, dragHandleColor, children}: LeftSidebarDragBlockProps) {
    return (
        <Draggable draggableId={draggableId} index={index}>
            {(provided) => (
                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={blockCss.layoutElement}>
                    <div className={blockCss.dragHandle} style={{backgroundColor: dragHandleColor.toString()}} />
                    <div className={blockCss.blockName}>{children}</div>
                </div>
            )}
        </Draggable>
    );
}

const blockCss = stylesheet({
    blockName: {
        padding: 15,
    },
    dragHandle: {
        width: 16,
    },
    layoutElement: {
        marginBottom: 15,
        display: 'flex',
        textAlign: 'center',
        borderRadius: 2,
        backgroundColor: WhiteColor,
        boxShadow: Shadow1,
        $nest: {
            '&:last-child': {
                marginBottom: 0,
            },
        },
    },
});



// WEBPACK FOOTER //
// ./src/report/views/LeftSideBarDragBlock.tsx